export default __webpack_public_path__ + "static/media/loginImg.a6729f4d.png";